import { useQuery } from '@tanstack/react-query';
import { getGeoreferencedMaps } from '~/api/georeferencedMaps';
import { useVisualizeGeoreferencedMapsEnabled } from './useVisualizeGeoreferencedMapsEnabled';

// Refetch before the 1h signed `pngUrl`s and `sourceFileUrl`s expire.
export const GEOREFERENCED_MAPS_REFETCH_INTERVAL_MS = 45 * 60 * 1000;

export function georeferencedMapsQueryKey(projectId: string | undefined) {
  return ['georeferencedMaps', { projectId }] as const;
}

/** Fetch only for a project, and only once `visualize-georeferenced-maps` has resolved on for the active org. */
export function georeferencedMapsQueryEnabled(projectId: string | undefined, resolved: boolean, enabled: boolean) {
  return !!projectId && resolved && enabled;
}

export function useGeoreferencedMaps(projectId: string | undefined) {
  const { resolved, enabled } = useVisualizeGeoreferencedMapsEnabled();

  return useQuery({
    enabled: georeferencedMapsQueryEnabled(projectId, resolved, enabled),
    queryKey: georeferencedMapsQueryKey(projectId),
    queryFn: () => {
      if (!projectId) throw new Error('projectId is required');
      return getGeoreferencedMaps(projectId);
    },
    refetchInterval: GEOREFERENCED_MAPS_REFETCH_INTERVAL_MS,
    // The interval pauses in a background tab, so returning after it lapses refetches before a signed URL is used.
    staleTime: GEOREFERENCED_MAPS_REFETCH_INTERVAL_MS,
    refetchOnWindowFocus: true,
  });
}
